import { render, staticRenderFns } from "./import-api.vue?vue&type=template&id=810000fe&"
import script from "./import-api.vue?vue&type=script&lang=js&"
export * from "./import-api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports